/**
 * Comprehensive Phrases Data - Elementary School Extended
 * 小学阶段扩展短语
 *
 * 补充更多场景短语，约60个
 */

import { Phrase } from './phrases-types';

export const elementaryExtendedPhrases: Phrase[] = [
  // ==================== 购物与金钱 Shopping & Money ====================

  {
    id: 'elem_go_shopping',
    phrase: 'go shopping',
    phonetic: '/ɡoʊ ˈʃɒpɪŋ/',
    meaning: '去购物',
    usageScenario: '描述去商店或超市买东西',
    example: "Let's go shopping this weekend.",
    exampleTranslation: '我们这个周末去购物吧。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_buy_some',
    phrase: 'buy some...',
    phonetic: '/baɪ sʌm/',
    meaning: '买一些……',
    usageScenario: '描述购买某物',
    example: 'I want to buy some apples.',
    exampleTranslation: '我想买一些苹果。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_how_much',
    phrase: 'How much is it?',
    phonetic: '/haʊ mʌtʃ ɪz ɪt/',
    meaning: '多少钱？',
    usageScenario: '询问价格',
    example: 'This book looks nice. How much is it?',
    exampleTranslation: '这本书看起来不错。多少钱？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_very_cheap',
    phrase: 'very cheap',
    phonetic: '/ˈveri tʃiːp/',
    meaning: '很便宜',
    usageScenario: '描述价格低',
    example: 'This bag is very cheap.',
    exampleTranslation: '这个包很便宜。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_very_expensive',
    phrase: 'very expensive',
    phonetic: '/ˈveri ɪkˈspensɪv/',
    meaning: '很贵',
    usageScenario: '描述价格高',
    example: 'This car is very expensive.',
    exampleTranslation: '这辆车很贵。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_save_money',
    phrase: 'save money',
    phonetic: '/seɪv ˈmʌni/',
    meaning: '省钱',
    usageScenario: '描述存钱或节约',
    example: 'I want to save money.',
    exampleTranslation: '我想省钱。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 旅游与出行 Travel ====================

  {
    id: 'elem_take_photos',
    phrase: 'take photos',
    phonetic: '/teɪk ˈfoʊtoʊz/',
    meaning: '拍照',
    usageScenario: '描述照相的动作',
    example: 'I like to take photos.',
    exampleTranslation: '我喜欢拍照。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_have_a_trip',
    phrase: 'have a trip',
    phonetic: '/hæv ə trɪp/',
    meaning: '去旅行',
    usageScenario: '描述旅游出行',
    example: 'We will have a trip next week.',
    exampleTranslation: '我们下周要去旅行。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_by_plane',
    phrase: 'by plane',
    phonetic: '/baɪ pleɪn/',
    meaning: '坐飞机',
    usageScenario: '描述交通方式',
    example: 'I go to Beijing by plane.',
    exampleTranslation: '我坐飞机去北京。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_by_train',
    phrase: 'by train',
    phonetic: '/baɪ treɪn/',
    meaning: '坐火车',
    usageScenario: '描述交通方式',
    example: 'They travel by train.',
    exampleTranslation: '他们坐火车旅行。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_on_foot',
    phrase: 'on foot',
    phonetic: '/ɒn fʊt/',
    meaning: '步行',
    usageScenario: '描述走路的交通方式',
    example: 'I go to school on foot.',
    exampleTranslation: '我步行去学校。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 节日与庆祝 Festivals ====================

  {
    id: 'elem_happy_birthday',
    phrase: 'Happy Birthday!',
    phonetic: '/ˈhæpi ˈbɜːrθdeɪ/',
    meaning: '生日快乐！',
    usageScenario: '祝贺生日',
    example: 'Happy Birthday to you!',
    exampleTranslation: '祝你生日快乐！',
    category: 'social',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_happy_new_year',
    phrase: 'Happy New Year!',
    phonetic: '/ˈhæpi nuː jɪr/',
    meaning: '新年快乐！',
    usageScenario: '新年祝贺',
    example: 'Happy New Year! Best wishes!',
    exampleTranslation: '新年快乐！万事如意！',
    category: 'social',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_merry_christmas',
    phrase: 'Merry Christmas!',
    phonetic: '/ˈmeri ˈkrɪsməs/',
    meaning: '圣诞快乐！',
    usageScenario: '圣诞节祝贺',
    example: 'Merry Christmas and Happy New Year!',
    exampleTranslation: '圣诞快乐，新年快乐！',
    category: 'social',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_make_a_wish',
    phrase: 'make a wish',
    phonetic: '/meɪk ə wɪʃ/',
    meaning: '许愿',
    usageScenario: '描述许下愿望',
    example: 'Make a wish before blowing the candles.',
    exampleTranslation: '吹蜡烛前许个愿。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_have_a_party',
    phrase: 'have a party',
    phonetic: '/hæv ə ˈpɑːrti/',
    meaning: '开派对',
    usageScenario: '描述举办聚会',
    example: "Let's have a birthday party!",
    exampleTranslation: '让我们开个生日派对吧！',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 家庭生活 Family Life ====================

  {
    id: 'elem_do_housework',
    phrase: 'do housework',
    phonetic: '/duː ˈhaʊswɜːrk/',
    meaning: '做家务',
    usageScenario: '描述家庭劳动',
    example: 'I help my mom do housework.',
    exampleTranslation: '我帮妈妈做家务。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_clean_the_room',
    phrase: 'clean the room',
    phonetic: '/kliːn ðə ruːm/',
    meaning: '打扫房间',
    usageScenario: '描述清洁房间',
    example: 'I clean my room every week.',
    exampleTranslation: '我每周打扫房间。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_wash_dishes',
    phrase: 'wash dishes',
    phonetic: '/wɒʃ ˈdɪʃɪz/',
    meaning: '洗碗',
    usageScenario: '描述清洗餐具',
    example: 'I help wash dishes after dinner.',
    exampleTranslation: '晚饭后我帮忙洗碗。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_make_the_bed',
    phrase: 'make the bed',
    phonetic: '/meɪk ðə bed/',
    meaning: '整理床铺',
    usageScenario: '描述整理床铺',
    example: 'I make the bed every morning.',
    exampleTranslation: '我每天早上整理床铺。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_water_flowers',
    phrase: 'water flowers',
    phonetic: '/ˈwɔːtər ˈflaʊərz/',
    meaning: '浇花',
    usageScenario: '描述给植物浇水',
    example: 'I water flowers every day.',
    exampleTranslation: '我每天浇花。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 社交活动 Social Activities ====================

  {
    id: 'elem_play_together',
    phrase: 'play together',
    phonetic: '/pleɪ təˈɡeðər/',
    meaning: '一起玩',
    usageScenario: '描述共同游戏',
    example: 'We play together after school.',
    exampleTranslation: '我们放学后一起玩。',
    category: 'actions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_talk_to',
    phrase: 'talk to...',
    phonetic: '/tɔːk tuː/',
    meaning: '和……说话',
    usageScenario: '描述交谈',
    example: 'I want to talk to you.',
    exampleTranslation: '我想和你说话。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_make_friends',
    phrase: 'make friends',
    phonetic: '/meɪk frendz/',
    meaning: '交朋友',
    usageScenario: '描述建立友谊',
    example: 'I want to make new friends.',
    exampleTranslation: '我想交新朋友。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_share_with',
    phrase: 'share with',
    phonetic: '/ʃeər wɪð/',
    meaning: '和……分享',
    usageScenario: '描述分享物品或经历',
    example: 'I like to share with my friends.',
    exampleTranslation: '我喜欢和朋友分享。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_help_each_other',
    phrase: 'help each other',
    phonetic: '/help iːtʃ ˈʌðər/',
    meaning: '互相帮助',
    usageScenario: '描述互相协助',
    example: 'We should help each other.',
    exampleTranslation: '我们应该互相帮助。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 学习与技能 Learning & Skills ====================

  {
    id: 'elem_practice_english',
    phrase: 'practice English',
    phonetic: '/ˈpræktɪs ˈɪŋɡlɪʃ/',
    meaning: '练习英语',
    usageScenario: '描述英语学习',
    example: 'I practice English every day.',
    exampleTranslation: '我每天练习英语。',
    category: 'academic',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_learn_by_heart',
    phrase: 'learn by heart',
    phonetic: '/lɜːrn baɪ hɑːrt/',
    meaning: '背诵/记住',
    usageScenario: '描述记忆学习',
    example: 'Learn new words by heart.',
    exampleTranslation: '背熟新单词。',
    category: 'academic',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_take_notes',
    phrase: 'take notes',
    phonetic: '/teɪk noʊts/',
    meaning: '记笔记',
    usageScenario: '描述课堂记录',
    example: 'I take notes in class.',
    exampleTranslation: '我上课记笔记。',
    category: 'academic',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_answer_questions',
    phrase: 'answer questions',
    phonetic: '/ˈænsər ˈkwestʃənz/',
    meaning: '回答问题',
    usageScenario: '描述课堂互动',
    example: 'Please answer the questions.',
    exampleTranslation: '请回答问题。',
    category: 'academic',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_ask_questions',
    phrase: 'ask questions',
    phonetic: '/æsk ˈkwestʃənz/',
    meaning: '提问',
    usageScenario: '描述询问',
    example: 'Don\'t be afraid to ask questions.',
    exampleTranslation: '不要害怕提问。',
    category: 'academic',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_work_hard',
    phrase: 'work hard',
    phonetic: '/wɜːrk hɑːrd/',
    meaning: '努力工作/学习',
    usageScenario: '描述勤奋努力',
    example: 'You must work hard.',
    exampleTranslation: '你必须努力学习。',
    category: 'academic',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 情感表达扩展 Extended Feelings ====================

  {
    id: 'elem_be_happy_about',
    phrase: 'be happy about',
    phonetic: '/biː ˈhæpi əˈbaʊt/',
    meaning: '为……感到高兴',
    usageScenario: '表达开心的原因',
    example: 'I am happy about the news.',
    exampleTranslation: '我为这个消息感到高兴。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_be_sad_about',
    phrase: 'be sad about',
    phonetic: '/biː sæd əˈbaʊt/',
    meaning: '为……感到难过',
    usageScenario: '表达难过的原因',
    example: 'He is sad about his mistake.',
    exampleTranslation: '他为自己的错误感到难过。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_be_good_to',
    phrase: 'be good to',
    phonetic: '/biː ɡʊd tuː/',
    meaning: '对……好',
    usageScenario: '描述待人友善',
    example: 'Be good to your friends.',
    exampleTranslation: '对你的朋友好一点。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_be_kind_to',
    phrase: 'be kind to',
    phonetic: '/biː kaɪnd tuː/',
    meaning: '对……友善',
    usageScenario: '描述友善待人',
    example: 'We should be kind to animals.',
    exampleTranslation: '我们应该善待动物。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 更多动词短语 More Verb Phrases ====================

  {
    id: 'elem_get_ready',
    phrase: 'get ready',
    phonetic: '/ɡet ˈredi/',
    meaning: '准备好',
    usageScenario: '描述准备状态',
    example: 'Get ready for school.',
    exampleTranslation: '准备好去学校。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_have_fun',
    phrase: 'have fun',
    phonetic: '/hæv fʌn/',
    meaning: '玩得开心',
    usageScenario: '描述愉快的体验',
    example: 'Have fun at the party!',
    exampleTranslation: '在派对上玩得开心！',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_have_a_look',
    phrase: 'have a look',
    phonetic: '/hæv ə lʊk/',
    meaning: '看一看',
    usageScenario: '描述查看',
    example: 'Let me have a look.',
    exampleTranslation: '让我看一看。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_have_a_try',
    phrase: 'have a try',
    phonetic: '/hæv ə traɪ/',
    meaning: '试一试',
    usageScenario: '描述尝试',
    example: 'Come on! Have a try!',
    exampleTranslation: '来吧！试一试！',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_take_a_break',
    phrase: 'take a break',
    phonetic: '/teɪk ə breɪk/',
    meaning: '休息一下',
    usageScenario: '描述短暂休息',
    example: "Let's take a break.",
    exampleTranslation: '让我们休息一下。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_take_care_of',
    phrase: 'take care of',
    phonetic: '/teɪk keər əv/',
    meaning: '照顾',
    usageScenario: '描述照料',
    example: 'I take care of my little sister.',
    exampleTranslation: '我照顾我的小妹妹。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_find_out',
    phrase: 'find out',
    phonetic: '/faɪnd aʊt/',
    meaning: '找出/发现',
    usageScenario: '描述发现信息',
    example: 'Let\'s find out the answer.',
    exampleTranslation: '让我们找出答案。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_come_true',
    phrase: 'come true',
    phonetic: '/kʌm truː/',
    meaning: '实现',
    usageScenario: '描述愿望或梦想成真',
    example: 'Your dream will come true.',
    exampleTranslation: '你的梦想会实现的。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'elem_hurry_up',
    phrase: 'hurry up',
    phonetic: '/ˈhɜːri ʌp/',
    meaning: '快点',
    usageScenario: '催促加快速度',
    example: 'Hurry up! We are late.',
    exampleTranslation: '快点！我们迟到了。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'elem_slow_down',
    phrase: 'slow down',
    phonetic: '/sloʊ daʊn/',
    meaning: '慢下来',
    usageScenario: '描述减速或放慢',
    example: 'Slow down! It\'s dangerous.',
    exampleTranslation: '慢点！危险。',
    category: 'actions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
];